import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { ROUTES_MAP } from 'app/shared/utils/routes';
import { isExternalIdDetectedError } from 'app/shared/utils/externalIdError';

export const useExternalIdRedirect = (failureReason: unknown) => {
  const history = useHistory();

  useEffect(() => {
    if (isExternalIdDetectedError(failureReason)) {
      const qs = new URLSearchParams();
      if (failureReason.hash_id) qs.set('hash_id', failureReason.hash_id);
      if (failureReason.object_type) qs.set('type', failureReason.object_type);
      if (failureReason.exists_in_opensearch != null)
        qs.set('exists', String(failureReason.exists_in_opensearch));
      history.replace(`${ROUTES_MAP.externalIdDetected.path}?${qs.toString()}`);
    }
  }, [failureReason, history]);
};
